<template>
    <div>
        <CommonPopupFrame :isShowBackground="isShowBackground" :isBlur="true" background="#fffc" :changeBottom="0" :changeHeight="isPageFrame ? 95 : 100" :isOpen="isShowMakeRequestJoinForm" :closeCompleteAction="closeRequestJoinForm">
            <div @touchstart.stop="() => { }" @touchend.stop="() => { }" @click="closeRequestJoinForm(false)" style="padding: 16px 20px; font-weight: 700; width: 100px;">닫기</div>
            <div style="height: 100%; overflow-y: hidden; display: flex; flex-direction: column;">
                <transition name="fade">
                    <div v-if="step === 1 && showContents" style="height: 100%; padding: 0 12px; overflow-y: scroll;" @touchmove.stop="() => { }">
                        <div v-if="isLearn && mode === 'update'" style="margin-top: 44px; text-align: center; font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px;">배우고 싶은 축구 기술이나<br>궁금한 내용을 적어보세요</div>
                        <div v-else style="margin-top: 44px; text-align: center; font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px;">감독님들에게 보여드릴<br>입단 요청서를 만들어볼게요</div>
                        <div style="font-size: 12px; line-height: 20px; font-weight: 700; margin-bottom: 2px;">⭐ 본인을 어필할 수 있게 길게 작성해 보세요</div>
                        <textarea v-model="contents" :placeholder="placeholder" style="min-height: 114px; outline: none; resize: none; line-height: 32px; border: none; width: 100%; border-radius: 12px; background-color: #210F030D; padding: 12px;" name="" id=""></textarea>
                        <div style="margin-top: 32px;">
                            <div style="font-weight: 700; font-size: 12px; line-height: 20px;">본인의 실력을 보여줄 수 있는 사진이나 영상을 함께 올리면 더 많은 팀으로부터 제안을 받을 수 있어요🚀</div>
                            <div style="font-weight: 700; font-size: 12px; line-height: 20px; color: #808080;">최소 한 장의 미디어를 추가해주세요</div>
                            <div style="display: flex; margin: 0 -12px; padding: 0 12px; gap: 12px; margin-top: 8px; overflow-x: scroll;" class="hide_scroll">
                                <div v-for="each, i in 3" :key="i">
                                    <div v-if="!imgSrcArr[i]" @click="showFiles(i)" style="width: 200px; height: 200px; background-color: #210F034D; gap: 8px; flex-direction: column; border-radius: 12px; flex-shrink: 0; display: flex; justify-content: center; align-items: center;">
                                        <img style="width: 32px;" :src="require('@/assets/img/request_form_img.png')" alt="">
                                        <div style="font-size: 12px; line-height: 24px; font-weight: 700; color: #fff;">이미지 추가</div>
                                    </div>
                                    <div style="position: relative;" v-else-if="imgSrcArr[i] && !imgSrcArr[i].isVideo">
                                        <img style="width: 200px; height: 200px; border-radius: 12px; object-fit: cover;" :src="imgSrcArr[i].src" alt="">
                                        <div @click="deleteImg(i)" style="position: absolute; right: 12px; bottom: 12px;">
                                            <img style="width: 32px;" :src="require('@/assets/img/delete_img.png')" alt="">
                                        </div>
                                    </div>
                                    <div style="position: relative;" v-else-if="imgSrcArr[i] && imgSrcArr[i].isVideo">
                                        <video preload="none" width="200" height="200" style="border-radius: 12px;" autoplay="false">
                                            <source :src="imgSrcArr[i].src + $Util.getStrForVideoPreview()" type="video/mp4">
                                        </video>
                                        <div @click="deleteImg(i)" style="position: absolute; right: 12px; bottom: 12px;">
                                            <img style="width: 32px;" :src="require('@/assets/img/delete_img.png')" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 32px; margin-bottom: 30px;">
                            <div style="font-weight: 700; font-size: 12px; line-height: 20px;">유튜브에 영상이 있다면 링크를 첨부해주세요</div>
                            <div style="position:relative; margin-top: 8px;">
                                <img :src="require('@/assets/img/soccerhow_write_link_url.png')" style="position:absolute; left:12px; top: 50%; transform: translateY(-50%); width:20px; height:18px;">
                                <input style="border:0px; height: 56px; border-radius: 12px; outline:none; width:100%; background-color: #210F030D; font-size:16px;color:black; padding: 10px 0px; padding-left:37px;" placeholder="유튜브 URL" @blur="detectLink" @click.stop ref="linkRef" v-model="youtubeLink" />
                            </div>
                            <div v-if="isShowYoutubeFrame" style="border-radius:12px;overflow:hidden; margin-top: 8px;">
                                <ContentsViewer :contents="youtubeLink" style="" />
                            </div>
                        </div>
                    </div>
                </transition>
                <transition name="fade">
                    <div v-if="step === 2 && showContents" style="height: 100%; padding: 0 12px; overflow-y: scroll;" @touchmove.stop="() => { }">
                        <div style="margin-top: 80px; text-align: center;">
                            <div @click="test" style="font-weight: 500; font-size: 20px; line-height: 32px;">모든 요청서는 <span style="font-weight: 700;">전체 공개됩니다</span></div>
                            <div style="font-weight: 500; font-size: 20px; margin-top: 20px; line-height: 32px">그리고 <span style="font-weight: 700;">원하는 팀</span>에 들어가기 위해서는<br><span style="font-weight: 700;">감독님</span>에게 직접 요청서를 보내는 게 좋아요</div>
                        </div>
                        <div style="background: linear-gradient(180deg, rgba(235, 235, 235, 0.5) 0%, rgba(255, 239, 228, 0.5) 100%); border-radius: 12px; padding-bottom: 20px; margin-top: 20px;">
                            <table>
                                <thead>
                                    <tr>
                                        <th>혜택</th>
                                        <th>일반 요청서</th>
                                        <th>다이렉트 요청서</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            전체 공개
                                            <div class="description">요청서 피드에 전체 공개</div>
                                        </td>
                                        <td>
                                            <div class="circle"></div>
                                        </td>
                                        <td>
                                            <div class="circle"></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="description">요청서 리포트</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            요청서 조회 확인
                                            <div class="description">감독님이 요청서를 봤을 때 알림</div>
                                        </td>
                                        <td>
                                            <div class="circle_gray"></div>
                                        </td>
                                        <td>
                                            <div class="circle"></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            경쟁 선수 확인
                                            <div class="description">같은 감독님에게 보낸 회원 조회</div>
                                        </td>
                                        <td>
                                            <div class="circle_gray"></div>
                                        </td>
                                        <td>
                                            <div class="circle"></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            적합도 판단
                                            <div class="description">입단 확률 제공</div>
                                        </td>
                                        <td>
                                            <div class="circle_gray"></div>
                                        </td>
                                        <td>
                                            <div class="circle"></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            내 요청서 상담 노출
                                            <div class="description">일주일 간 상담 노출</div>
                                        </td>
                                        <td>
                                            <div class="circle_gray"></div>
                                        </td>
                                        <td>
                                            <div class="circle"></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </transition>
                <transition name="fade">
                    <div v-if="step === 3 && showContents" style="height: 100%; padding: 0 12px; overflow-y: scroll;" @touchmove.stop="() => { }">
                        <div style="margin-top: 80px; text-align: center;">
                            <div style="font-weight: 700; font-size: 20px; line-height: 32px;">요청서 종류를 선택하세요</div>
                            <div style="margin-top: 60px;">
                                <div style="margin-bottom: 12px;">
                                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px;">보내고 싶은 팀을 선택해 직접 전달할 수 있어요!</div>
                                    <div @click="setIsDirectForm(); $Util.sendEventClick('사커하우_요청서작성_다이렉트요청서보내기', true)" style="background: linear-gradient(180deg, #FFAF79 0%, #FFD9BF 100%); height: 97px; width: 310px; margin: 0 auto; border-radius: 24px; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 16px;">
                                        <div style="font-weight: 700;">다이렉트 요청서 보내기</div>
                                        <div style="display: flex; align-items: center; color: #606060; gap: 4px; font-weight: 500; font-size: 14px; line-height: 16px;">
                                            관심
                                            <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #210F03B2;"></span>
                                            <span style="font-weight: 700; color: #210f03;">{{ likeTeamList.length }}개</span>의 팀
                                        </div>
                                    </div>
                                </div>
                                <div @click="CommonRequestFormConfirm(); $Util.sendEventClick('사커하우_요청서작성_일반요청서작성하기', true)" style="width: 310px; height: 96px; border-radius: 24px; background-color: #fff; margin: 0 auto; display: flex; justify-content: center; align-items: center;">
                                    <div style="font-weight: 700; font-size: 14px;">일반 요청서 작성하기</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <transition name="fade">
                    <div style="flex: 1; overflow-y: hidden;" @touchmove.stop="() => { }" v-if="isDirectForm">
                        <div @click="closeDirectForm" style="display:flex; position: relative; align-items: center; margin-top: 46px;">
                            <img v-if="!isHideBackBtn" :src="require('@/assets/images/mypage/ico-move.png')" style="width: 10px; transform: rotate(180deg);margin-left: 20px;">
                            <span v-if="!isHideBackBtn" style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
                            <div style="text-align: center; position: absolute; left: 50%; top: -7px; transform: translateX(-50%);">
                                <div style="font-weight: 700; font-size: 20px; line-height: 32px;">어디에 보낼까요?</div>
                                <div style="font-weight: 500; font-size: 14px; color: #808080; line-height: 21px; margin-top: 4px;">🚀 한 개의 팀에 보낼 수 있습니다</div>
                            </div>
                        </div>
                        <div style="margin-top:50px; display:flex; padding:0px 12px;">
                            <div @click="showAgeSort" :style="{ border: '1px solid #d9d9d9'}" style="padding: 8px 12px; display: flex; gap: 4px; align-items: center; font-weight: 700; font-size: 14px; border-radius: 50px; border: 2px solid #210f03;">
                                <div style="line-height: 24px; ">{{sort_age}}</div>
                                <img style="width: 6px; transform: rotate(90deg);" :src="require('@/assets/img/right_arrow.png')" alt="">
                            </div>
                        </div>
                        <div style="height: 100%; margin-top: 10px; overflow-y: scroll; padding: 0 12px; padding-bottom: 120px;">
                            <template v-if="likeTeamList.length > 0">
                                <div @click="sendRequestFormConfirm(each)" v-for="each, i in likeTeamList" :key="i" style="display: flex; gap: 12px; align-items: center; border-bottom: 1px solid #d9d9d9; padding: 24px 0;">
                                    <div>
                                        <img style="width: 80px;" :src="$resourcePath + each.image_path" alt="">
                                    </div>
                                    <div style="display: flex; flex-direction: column; gap: 6px;">
                                        <div style="font-weight: 700; line-height: 24px;">{{ each.name }}</div>
                                        <div style="display: flex; gap: 8px;">
                                            <div style="padding: 2px 4px; line-height: 20px; font-size: 12px; font-weight: 500; background-color: #d9d9d9; border-radius: 4px;">{{ each.manager ? each.manager.name : '' }}</div>
                                            <div style="padding: 2px 4px; line-height: 20px; font-size: 12px; font-weight: 500; background-color: #d9d9d9; border-radius: 4px;">{{ each.type }}</div>
                                            <div style="padding: 2px 4px; line-height: 20px; font-size: 12px; font-weight: 500; background-color: #d9d9d9; border-radius: 4px;">{{ each.place.name }}</div>
                                        </div>
                                        <div style="display: flex; align-items: center; gap: 4px;">
                                            <img :src="require('@/assets/img/team_star.svg')" alt="">
                                            <div style="font-weight: 700; font-size: 14px;">{{ each.like_cnt }}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div style="margin-top: 200px;">
                                    <div style="font-weight: 500; font-size: 14px; color: #606060; text-align: center;">관심을 갖고 있는 팀이 없습니다.</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </transition>
                <transition name="fade">
                    <div style="height: 100%; overflow-y: hidden;" @touchmove.stop="() => { }" v-if="step === 4 && isSelectTeam">
                        <div style="text-align: center; margin-top: 120px;">
                            <div v-if="sendStep === 1" style="font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px;">좋습니다!</div>
                            <div v-else-if="sendStep === 2" style="font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px; opacity: 0;">좋습니다!</div>
                            <div v-else-if="sendStep === 3" style="font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px;">좋은 결과 있길 바래요!</div>
                            <div>
                                <div>
                                    <img style="width: 80px;" :src="$resourcePath + selectedTeam.image_path" alt="">
                                </div>
                                <div style="font-size: 12px; font-weight: 700; line-height: 24px; color: #b5aaa3;">{{ selectedTeam.name }}</div>
                            </div>
                            <div style="margin-top: 40px;">
                                <div v-if="sendStep === 1" style="font-weight: 500; line-height: 32px; font-size: 20px;"><span style="font-weight: 700;">{{ selectedTeam.name }}</span>에<br>다이렉트 요청서를 보낼까요?</div>
                                <div v-else-if="sendStep === 2" style="font-weight: 500; line-height: 32px; font-size: 20px;"><span style="font-weight: 700;">{{ selectedTeam.name }}</span>에<br>다이렉트 요청서를 전달중입니다...</div>
                                <div v-else-if="sendStep === 3" style="font-weight: 500; line-height: 32px; font-size: 20px;"><span style="font-weight: 700;">{{ selectedTeam.name }}</span>에<br>다이렉트 요청서를 전달했고<br>요청서가 공개됐습니다!</div>
                            </div>
                            <div v-if="sendStep === 1" style="margin-top: 20px; font-weight: 700; font-size: 14px; line-height: 21px; padding: 0 20px;">
                                감독님께 바로 메시지<span style="font-weight: 500; color: #606060;">를 보내서</span>
                                입단 테스트 일정<span style="font-weight: 500; color: #606060;">을 잡을 수 있도록 도와드리겠습니다. 이후</span> 실제로 감독님을 만나 <span style="font-weight: 500; color: #606060;">입단 테스트를 진행할 수 있도록</span> 처음부터 끝까지 사커하우가 함께합니다.
                            </div>
                            <div style="margin-top: 40px; padding: 0 12px;">
                                <ProgressBar v-if="sendStep === 2" :hideProgressBar="hideProgressBar" :isStart="isStart"></ProgressBar>
                            </div>
                            <div style="margin-top: 40px;display:flex; justify-content: center; gap:10px;">
                                <div @click="sendOtherTeam(); $Util.sendEventClick('사커하우_요청서작성_요청서_다른팀에도보내기')" v-if="sendStep === 3" style="width: 150px; margin: 0 auto; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">다른 팀에도 보내기</div>
                                <div @click="showRequestReportDetail(); $Util.sendEventClick('사커하우_요청서작성_요청서_자세히보기')" v-if="sendStep === 3" style="width: 180px; margin: 0 auto; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">요청서 리포트로 이동하기</div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
            <div v-if="step !== 3 && !isSelectTeam && !hideButton && !isForce" style="height: 106px; backdrop-filter: blur(100px); background-color: rgba(255, 255, 255, 0.8); " :style="{ marginBottom: '-' + $GlobalStore.navigationBarHeight() + 'px', height: $GlobalStore.navigationBarHeight() + 106 + 'px' }">
                <div v-if="mode === 'insert'" @click="nextStep" style="width: 286px; font-weight: 700; font-size: 14px; color: var(--color-main); line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #210f03; margin: 0 auto; margin-top: 20px;">다음</div>
                <div v-else @click="makeRequestForm" style="width: 286px; font-weight: 700; font-size: 14px; color: var(--color-main); line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #210f03; margin: 0 auto; margin-top: 20px;">수정하기</div>
            </div>
            <div v-else-if="step === 4 && isSelectTeam && !hideButton" style="height: 116px; padding: 0 12px;">
                <div style="display: flex; gap: 12px;">
                    <div @click="goBack" style="width: 136px; font-weight: 700; font-size: 14px; line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #fff;">뒤로가기</div>
                    <div @click="sendRequestForm" style="flex: 1; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">보내기</div>
                </div>
            </div>
            <div v-else-if="isForce" style="height: 106px; backdrop-filter: blur(100px); background-color: rgba(255, 255, 255, 0.8); " :style="{ marginBottom: '-' + $GlobalStore.navigationBarHeight() + 'px', height: $GlobalStore.navigationBarHeight() + 106 + 'px' }">
                <div @click="makeRequestForm" style="width: 286px; font-weight: 700; font-size: 14px; color: var(--color-main); line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #210f03; margin: 0 auto; margin-top: 20px;">만들기</div>
            </div>
            <div style="display:flex; align-items: center;">
                <!-- 사진 여러장 업로드 할 시 input태그 추가 -->
                <input type="file" style="display:none;" ref="file0" data-id="file0" @change="readURL($event)">
                <input type="file" style="display:none;" ref="file1" data-id="file1" @change="readURL($event)">
                <input type="file" style="display:none;" ref="file2" data-id="file2" @change="readURL($event)">
            </div>
        </CommonPopupFrame>
        <CommonBookMarkPopup :height="changeHeight" :isShowBookmarkPopup="isShowBookmarkPopup" :closeBookmarkPopup="closeBookmarkPopup">
            <div @click="closeBookmarkPopup" style="font-weight: 700;">닫기</div>
            <div v-if="!isReject">
                <div style="margin-top: 40px; text-align: center;">
                    <img style="width: 250px" :src="require('@/assets/img/bookmark_logo2.png')" alt="">
                </div>
                <div style="margin-top: 24px; text-align: center; white-space: nowrap; font-weight: 700; font-size: 20px; line-height: 32px;">감독님들은 회원님의 요청을 기다리고있어요!<br>다이렉트 요청서를 보내보는 건 어떨까요?</div>
                <div style="display: flex; gap: 12px; margin-top: 60px;">
                    <div @click="rejectDirectForm(); $Util.sendEventClick('사커하우_요청서작성_일반요청서_작성하기')" style="flex: 1; font-weight: 700; font-size: 14px; line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #fff;">괜찮아요</div>
                    <div @click="setIsDirectForm(true); $Util.sendEventClick('사커하우_요청서작성_다이렉트요청서작성')" style="flex: 1; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">네, 직접 보낼게요</div>
                </div>
            </div>
            <div style="margin-top: 40px;" v-else>
                <div style="margin-top: 24px; text-align: center; white-space: nowrap; font-weight: 700; font-size: 20px; line-height: 32px;">알겠습니다! 꼭 지금이 아니어도<br>언제든 팀에 다이렉트 요청서를 보낼 수 있어요</div>
                <div @click="makeRequestForm" style="margin-top: 40px; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">확인</div>
            </div>
        </CommonBookMarkPopup>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ContentsViewer from "@/components/common/ContentsViewer";
import ProgressBar from '@/components/soccerhowmain/ProgressBar';
import CommonBookMarkPopup from '@/components/soccerhowmain/CommonBookMarkPopup';
import { SOCCER_HOW_TYPE } from '@/Constants'
import BottomPopupMenu from "../common/BottomPopupMenu";
import {SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN} from "../../Constants";

export default {
    name: 'MakeRequestJoinForm',
    components: {BottomPopupMenu, CommonPopupFrame, ContentsViewer, ProgressBar, CommonBookMarkPopup },
    props: {
        isShowMakeRequestJoinForm: {
            type: Boolean,
            default: false
        },
        closeRequestJoinForm: {
            type: Function,
            default: () => { }
        },
        mode: {
            type: String,
            default: 'insert'
        },
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        },
        isLearn: {
            type: Boolean,
            default: false
        },
        isFromReportList: {
            type: Boolean,
            default: false
        },
        isShowBackground: {
            type: Boolean,
            default: true
        },
        isHideBackBtn: {
            type: Boolean,
            default: false
        },
        isForce: {
            type: Boolean,
            default: false
        },
        isPageFrame: {
            type: Boolean,
            default: false
        },
        passStep: {
            type: Number,
            default: 1
        },
        preparedFormData: {
            type: [FormData, Object],
            default: () => new FormData()
        }
    },
    watch: {
        isShowMakeRequestJoinForm(newVal) {
            if (!newVal) {
                this.step = 1
                this.contents = ''
                this.imgSrcArr = [null, null, null]
                this.showContents = true
                this.isDirectForm = false
                this.isSelectTeam = false
                this.sendStep = 1
                this.isStart = false
                this.hideButton = false
                this.youtubeLink = ''
                for (let i = 0; i < 3; i++) {
                    this.$refs['file' + i].value = ''
                }
                this.closeBookmarkPopup()
            } else {
                if (this.mode === 'update') {
                    this.getSoccerhows()
                }
                if (this.isFromReportList) {
                    this.getLikeTeamList()
                    this.setIsDirectForm()
                    this.step = 3
                }
                if (this.passStep !== 1) {
                    this.step = this.passStep;
                }
            }
        },
        step(newVal) {
            if (newVal === 3) {
                this.getLikeTeamList()
            }
        }
    },
    data() {
        return {
            isShowYoutubeFrame: false,
            youtubeLink: '',
            step: 1,
            showContents: true,
            isDirectForm: false,
            isSelectTeam: false,
            sendStep: 1,
            isStart: false,
            hideButton: false,
            isShowBookmarkPopup: false,
            changeHeight: 473,
            isReject: false,
            contents: '',
            imgSrcArr: [null, null, null],
            curIndex: -1,
            likeTeamList: [],
            selectedTeam: {},
            isLoading: false,
            placeholder: 'ex) 저는 서울에 사는 14살 김하우입니다. 키는 165cm이고 포지션은 공격수입니다. 선수 경력은 2년이고 제 장점은 빠른 달리기와 지치지 않는 체력입니다.',
            menuOptions : {},
            isShowPopMenu : false,
            sort_age : '모든 나이대'

        }
    },
    methods: {
        showAgeSort(){
            this.isShowPopMenu = true
            const labelAndAction = [];

            labelAndAction.push(
                {
                    label: '모든 나이대', action: () => {
                        this.isShowPopMenu = false;
                        this.sort_age = '모든 나이대';
                        this.getLikeTeamList();
                    },
                },
            )

            labelAndAction.push(
                {
                    label: '초등학교', action: () => {
                        this.isShowPopMenu = false;
                        this.sort_age = 'U12';
                        this.getLikeTeamList();
                    },
                },
            )

            labelAndAction.push(
                {
                    label: '중학교', action: () => {
                        this.isShowPopMenu = false;
                        this.sort_age = 'U15';
                        this.getLikeTeamList();
                    },
                },
            )

            labelAndAction.push(
                {
                    label: '고등학교', action: () => {
                        this.isShowPopMenu = false;
                        this.sort_age = 'U18';
                        this.getLikeTeamList();
                    },
                },
            )

            labelAndAction.push(
                {
                    label: '대학교', action: () => {
                        this.isShowPopMenu = false;
                        this.sort_age = '대학팀';
                        this.getLikeTeamList();
                    },
                },
            )

            this.menuOptions = {
                labelAndAction: labelAndAction,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        sendOtherTeam(){
            this.$GlobalStore.addModal('MakeRequestJoinFormPopup', {soccerhowIdx : this.soccerhowIdx, isFromReportList: true, isModalBackTransparent: true})
        },
        checkYoutube() {
            if (this.$Util.checkYoutubeLink(this.contents)) {
                this.youtubeLink = this.$Util.getYoutubeLinkArr(this.contents)[0];
                this.isShowYoutubeFrame = true;
            }

            this.contents = this.$Util.removeYoutubeLink(this.contents);
        },
        checkIsVideo(src) {
            const extension = src.split('.').pop().toLowerCase()
            if (extension === 'mp4' || extension === 'mov' || extension === 'qt') {
                return true
            } else {
                return false
            }
        },
        async getSoccerhows() {
            const parameters = {};
            parameters.idx = this.soccerhowIdx
            parameters.isParentIdxesEmpty = true;
            parameters.isViewCntUpdate = false;

            const res = await this.$Axios.get('/api/soccerhow/list', { params: parameters });

            const data = res.data.soccerHows[0];
            this.contents = data.contents;

            this.checkYoutube()

            let index = 0;
            if (data.media_path1) {
                this.checkIsVideo(data.media_path1)
                this.imgSrcArr[0] = { src: this.$resourcePath + data.thumbnail_path1, id: 'file' + index, path: data.media_path1, thumPath: data.thumbnail_path1, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                index++;
            }
            if (data.media_path2) {
                this.checkIsVideo(data.media_path2)
                this.imgSrcArr[1] = { src: this.$resourcePath + data.thumbnail_path2, id: 'file' + index, path: data.media_path2, thumPath: data.thumbnail_path2, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                index++;
            }
            if (data.media_path3) {
                this.checkIsVideo(data.media_path3)
                this.imgSrcArr[2] = { src: this.$resourcePath + data.thumbnail_path3, id: 'file' + index, path: data.media_path3, thumPath: data.thumbnail_path3, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
            }
        },
        async getLikeTeamList() {
            // const res = await this.$Axios.get('/api/team/liked')
            //
            // const likeTeamList = res.data.team_liked

            const parameters = {};
            parameters.age = this.sort_age;

            const res = await this.$Axios.get('/api/team/list', {params : parameters});
            const likeTeamList = res.data.teams;

            this.likeTeamList = likeTeamList
        },
        setFormData(isDelete) {
            const formData = new FormData();
            formData.append('is_deleted', isDelete)
            formData.append('topic', '')
            formData.append('entredPoint', 0)
            formData.append('isCheckedFastAnswer', '0')
            formData.append('title', '');
            formData.append('contents', this.contents + this.youtubeLink);
            formData.append('type', SOCCER_HOW_TYPE.SC_JOIN)
            formData.append('mode', this.mode);
            formData.append('isYoutubeExist', (this.youtubeLink !== '' ? '1' : '0'));
            for (let i = 0; i < this.imgSrcArr.length; i++) {
                if (this.imgSrcArr[i]) {
                    const curImgSrc = this.imgSrcArr[i];
                    if (curImgSrc.isFileTag && this.$refs[curImgSrc.id].value !== '') {
                        formData.append('file' + i, this.$refs[curImgSrc.id].files[0]);
                    }
                }
            }
            if (this.mode === 'update') {
                formData.append('soccerhowIdx', this.soccerhowIdx);
                for (let i = 0; i < this.imgSrcArr.length; i++) {
                    if (this.imgSrcArr[i]) {
                        if (!this.imgSrcArr[i].isFileTag) {
                            formData.append('filePath' + i, this.imgSrcArr[i].path);
                            if (this.imgSrcArr[i].thumPath) formData.append('thumPath' + i, this.imgSrcArr[i].thumPath);
                        }
                    }
                }
            }
            return formData;
        },
        async makeRequestForm(isDelete = false, is_without_validation = false) {
            if (this.isLoading) {
                alert('처리 중입니다. 잠시만 기다려주세요.')
                return;
            }
            const allFalse = this.imgSrcArr.every(value => value === null);

            if (allFalse && !is_without_validation && this.step === 1) {
                this.$GlobalStore.showAlert('최소 한 장의 미디어를 추가해주세요')
                return
            }
            this.isLoading = true
            let formData = null;
            if (this.passStep > 1) {
                formData = this.preparedFormData
                formData.append('is_deleted', isDelete)
            } else {
                formData = this.setFormData(isDelete)
            }
            this.$GlobalStore.addModal('Loading', {
                transitionName: '',
                isModalBackTransparent: true,
            })

            const res = await this.$Axios.post('/api/soccerhow/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            if (res.data.code === 0) {
                this.$GlobalStore.closeLastModal()
                if (this.$GlobalStore.loginInfo().visit_reason === '축구선수 희망' || this.$GlobalStore.loginInfo().visit_reason === '축구 진로 상담' || this.$GlobalStore.loginInfo().visit_reason === '축구팀 입단') {
                    this.$Util.sendEventClick('축구팀입단_축구선수_희망_요청서작성', true)
                } else {
                    this.$Util.sendEventClick("축구팀입단_요청서작성", true)
                }
                this.isLoading = false
                if (res.data.login_info) {
                    this.$GlobalStore.setLoginInfo(res.data.login_info)
                }
                if (res.data.first_parent_idx) {
                    this.closeRequestJoinForm(true, res.data.first_parent_idx)
                    this.$GlobalStore.addModal('RequestReportDetailNew', { soccerhowIdx: res.data.first_parent_idx, is_parent_verified: false })
                } else {
                    this.closeRequestJoinForm(true)
                }
                return res
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
                this.$GlobalStore.closeLastModal()
                this.isLoading = false
            }
            return null
        },
        readURL(e) {
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp' || extension === 'mp4' || extension === 'mov' || extension === 'qt') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.files[0].value = '';
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                            return;
                        }

                        const data = { src: e.target.result, isVideo: false, id: input.getAttribute('data-id'), isFileTag: true, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                        if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.isVideo = true
                        // this.imgSrcArr = [...this.imgSrcArr, data];
                        this.$set(this.imgSrcArr, this.curIndex, data)
                    }
                    reader.readAsDataURL(input.files[0]);
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp, mp4, mov, qt만 업로드 가능합니다.');
                }
            }
        },
        deleteImg(i) {
            this.$set(this.imgSrcArr, i, null)
            this.$refs['file' + i].value = ''
        },
        showFiles(index) {
            this.curIndex = index
            // if (this.imgSrcArr.length >= 3) {
            //     alert('최대 3개까지 업로드 가능합니다.');
            //     return;
            // }

            // if (this.youtubeLink !== '') {
            //     const html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">기존에 업로드한 미디어가 삭제됩니다.<br>다른 미디어로 변경할까요?</div>`;
            //     this.$GlobalStore.showConfirm(html, async () => {
            //         this.inactiveAttachments();

            //         for (let i = 0; i < 3; i++) {
            //             if (this.$refs['file' + i].value === '') {
            //                 this.$refs['file' + i].click();
            //                 return;
            //             }
            //         }
            //     }, '변경하기', '취소', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })
            //     return;
            // }
            for (let i = 0; i < 3; i++) {
                if (this.$refs['file' + i].value === '') {
                    this.$refs['file' + i].click();
                    return;
                }
            }
        },
        rejectDirectForm() {
            this.isReject = true
            this.changeHeight = 280
        },
        closeBookmarkPopup() {
            this.isShowBookmarkPopup = false
            this.isReject = false
            this.changeHeight = 473
        },
        CommonRequestFormConfirm() {
            this.isShowBookmarkPopup = true
        },
        showRequestReportDetail() {
            this.$GlobalStore.addModal('RequestReportDetail')
            this.closeRequestJoinForm()
        },
        goBack() {
            this.isDirectForm = true
            this.isSelectTeam = false
            this.showContents = false
            this.sendStep = 1
            this.step = 3
        },
        detectLink() {
            const isYoutubeLinkComplete = this.$Util.checkYoutubeLink(this.youtubeLink);
            if (isYoutubeLinkComplete) {
                this.isShowYoutubeFrame = true;
            }
        },
        hideProgressBar() {
            this.sendStep = 3
        },
        nextStep() {
            if (this.step === 1 && !this.isFromReportList) {
                if (this.contents === '') {
                    this.$GlobalStore.showAlert('내용을 입력해주세요.');
                    return;
                }

                if (/(.)\1{3,}/.test(this.contents)) {
                    this.$GlobalStore.showAlert('같은 글자를 4개 이상 반복할 수 없습니다.');
                    return
                }

                if (this.contents.length < 5) {
                    this.$GlobalStore.showAlert('5자 이상 입력해주세요.')
                    return
                }

                if (this.youtubeLink !== '') {
                    if (!this.$Util.checkYoutubeLink(this.youtubeLink)) {
                        this.$GlobalStore.showAlert('잘못된 유튜브 링크 입니다.');
                        return;
                    }
                }

                const allFalse = this.imgSrcArr.every(value => value === null);

                if (allFalse) {
                    this.$GlobalStore.showAlert('최소 한 장의 미디어를 추가해주세요')
                    return
                }
            }
            this.showContents = false;
            let delayTime = this.step === 1 ? 1000 : 0
            setTimeout(() => {
                this.showContents = true
                this.step++
            }, delayTime)
        },
        test() {
            this.step--
        },
        setIsDirectForm(isFromModal) {
            if (isFromModal) {
                this.closeBookmarkPopup()
            }
            this.showContents = false
            this.isDirectForm = true
        },
        closeDirectForm() {
            this.showContents = true
            this.isDirectForm = false
        },
        sendRequestFormConfirm(selectedTeam) {
            this.$GlobalStore.addModal('SoccerTeamDetail', {
                from_screen : SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN.FROM_REQUEST_JOIN_TEAM_SELECTOR,
                teamIdx : selectedTeam.idx,
                completeAction : () => {
                    this.selectedTeam = selectedTeam;
                    this.isDirectForm = false;
                    this.isSelectTeam = true;
                    this.nextStep();
                }
            });
        },
        sendRequestForm() {
            if (this.sendStep === 1) {
                this.$GlobalStore.addModal('RequestPayForm', { isModalBackTransparent: true, completeAction: async() => {return await this.makeRequestForm(false, true)}, selectedTeam: this.selectedTeam, isFromTeam: this.isFromReportList, soccerhowIdx: this.soccerhowIdx })
                return
            }
            this.hideButton = true
            this.sendStep++
            setTimeout(() => {
                this.isStart = true
            }, 1000)
        }
    },
    created() {
        // this.makeRequestForm = this.$Once(this.makeRequestForm)
    }
}
</script>

<style scoped>
.progress-container {
    width: 100%;
    height: 12px;
    background-color: #ddd;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
}

.progress-bar {
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, #FF7111 0%, #FFD7BC 100%);
    transform: scaleX(0);
    border-radius: 12px;
    transform-origin: left;
    transition: transform 0s;
}

textarea::placeholder {
    color: #bbbbbb;
    font-size: 15px;
    line-height: 30px;
    font-weight: 500;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

table {
    border-collapse: collapse;
    overflow: hidden;
}

th,
td {
    text-align: center;
    padding: 10px;
    font-weight: 700;
    font-size: 14px;
}

td {
    font-size: 14px;
    color: var(--color-main)
}

tr {
    border-bottom: 1px solid #ebebeb;
}

.description {
    font-size: 12px;
    color: #606060;
    font-weight: 500;
    margin-top: 10px;
}

.circle {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #ff7f00;
    background-color: transparent;
}

.circle_gray {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #d9d9d9;
}
</style>